export default __webpack_public_path__ + "static/media/excellenceIcon.04253fad.png";